module.exports = __webpack_public_path__ + "icon-sketch@2x.png?2348c708415d35980648e7c5965d64d6";